export default function (list) {
    let retlist = {};
    list.forEach(name => {
        retlist[name] = {
            get() {
                return window.store.state[name];
            },
            set(value) {
                //'setobj', 'setarr', 'setvalue', 
                //'setobjarr', 'setobjvalue', 'setobjobj', 'cleararr', 'clearobjarr'
                if (typeof value == 'object') {
                    if (Array.isArray(value)) {
                        window.store.commit('cleararr', { n: name });
                        window.store.commit('setarr', { n: name, v: value });
                    } else if (value instanceof Date) {
                        window.store.commit('setvalue', { n: name, v: value });
                    } else {
                        window.store.commit('setobj', { n: name, v: value });
                    }
                } else {
                    window.store.commit('setvalue', { n: name, v: value });
                }
            },
        }
    });
    return retlist;
}
